import axios from 'axios'
import { Message } from 'element-ui'
import I18n from '../i18n'
import store from '../store'
import router from '../router'

//初始化对象
const instance = axios.create({ baseURL: '/api', method: 'GET', timeout: 80000, responseType: 'json', withCredentials: false })

// 请求拦截
instance.interceptors.request.use(
  config => {
    if('|/login/password|/login/code|'.indexOf(config.url) == -1) config.headers['Authorization'] = store.state.token.token || ''
    config.headers['dataSourceType'] = store.state.dataCenter.dataCenter || ''
    config.headers['gmt'] = store.state.gmt.gmt || ''
    config.headers['cType'] = 'PC'
    config.headers['Language'] = localStorage.getItem('language') || 'zh'

    //拦截参数拼装
    if(config.method == 'get') {
      config.url = config.url.indexOf('?') === -1 ? `${config.url}?dataSourceType=${store.state.dataCenter.dataCenter}&gmt=${store.state.gmt.gmt}` : `${config.url}&dataSourceType=${store.state.dataCenter.dataCenter}&gmt=${store.state.gmt.gmt}`
    } else {
      if(Object.prototype.toString.call(config.data) === '[object Null]') {
        config.data = { dataSourceType: store.state.dataCenter.dataCenter, gmt: store.state.gmt.gmt }
      } else if(Object.prototype.toString.call(config.data) === '[object Object]') {
        config.data.dataSourceType = store.state.dataCenter.dataCenter
        config.data.gmt = store.state.gmt.gmt
      }
    }

    return config
  },
  error => {
    return Promise.reject(error.message)
  }
)

//错误提示消息过滤转义
const filterErrorMsg = (code, msg) => {
  if (
    code === 400 ||
    code === 401 ||
    code === 404 ||
    code === 500 ||
    code === 503
  ) {
    return I18n.t(`base.error.${code}`)
  }

  return msg
}

//返回错误结果处理
const errorResult = (n, c, m, d) => {
  if (!n) Message({ message: m, type: 'error' })
  return c ? new Promise(() => {}) : Promise.reject(m, d)
}

//响应拦截器
instance.interceptors.response.use(
  response => {
    //处理HTTP状态
    if (response.status === 200) {
      if(!response.config.notbody) {
        //处理应用状态
        if (response.data.code === 200) {
          return Promise.resolve(response.data.data)
        } else {
          return errorResult(response.config.notify, response.config.catch, filterErrorMsg(response.data.code, localStorage.getItem('language') == 'zh' ? response.data.message || '' : response.data.enMessage || ''), response.data.data || '')
        }
      } else {
        return Promise.resolve(response)
      }
    } else {
      return errorResult(response.config.notify, response.config.catch, filterErrorMsg(response.status, response.statusText))
    }
  },
  error => {
    //401授权码过期处理，跳转到登录界面
    if(error.response && error.response.status === 401) {
      setTimeout(() => {
        router.push({ path: '/login' })
      }, 1000)
    }

    return errorResult(error.config.notify, error.config.catch, filterErrorMsg(error.response ? error.response.status : 400, error.response ? error.response.data.message : error.message))
  }
)

export default instance
